import React from "react";
import { Link } from "react-router-dom";
import { useProducts } from "@/hooks/useProducts";
import { ProductCard } from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { Cookie, ArrowRight } from "lucide-react";

export default function ShopAll() {
  const { products } = useProducts();
  const popcorn = products.filter((p) => p.category === "popcorn");
  const pecans = products.filter((p) => p.category === "pecans");
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <p className="font-script text-gold text-3xl mb-1">Snacks for Every Occasion</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-black text-cream tracking-tight">Shop Everything</h1>
      </div>

      <h2 className="font-serif text-2xl text-gold mb-5">Gourmet Popcorn</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mb-16">
        {popcorn.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>

      <h2 className="font-serif text-2xl text-gold mb-5">Cinnamon Pecans</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mb-16">
        {pecans.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>

      <div className="gold-border-card rounded-2xl bg-burgundy/40 p-8 text-center">
        <Cookie className="text-gold mx-auto mb-3" size={34} />
        <h2 className="font-serif text-2xl text-cream">Gourmet Cookies — 2 for $6</h2>
        <p className="text-cream/60 mt-2">Mix & match any flavors in our easy cookie builder.</p>
        <Link to="/cookies"><Button className="btn-gold rounded-full px-7 py-6 mt-5 font-semibold" data-testid="shopall-cookies-btn">Build Your Cookie Box <ArrowRight size={16} className="ml-2" /></Button></Link>
      </div>
    </div>
  );
}
